import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "../../themes/themes";

export const ContentModalAppointment = styled.div`
  position: absolute;
  left: 25%;
  bottom: 30%;
  width: 600px;
  height: fit-content;
  max-width: 70%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  overflow: auto;
  @media only screen and (min-width: 769px) {
    left: 25%;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    left: 15%;
  }
  @media only screen and (max-width: 480px) {
    left: 15%;
  }
`;

export const CloseModalAppointment = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalAppointment = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: left;
  height: 24em;
  overflow-y: auto;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  h3 {
    font-weight: 600;
  }
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentTimeAppointment = styled.div`
  background: ${({ theme }) => theme.background.tertiary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 9em;
  padding-top: 1em;
  margin-bottom: 3em;
`;

export const ButtonAppointmentConfirm = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.button.primary};
  margin: 1em auto;
  color: ${({ theme }) => theme.primaryColorLight};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryGray};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ButtonAppointmentCancel = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.primaryBackgroundLight};
  margin: 1em auto;
  color: ${({ theme }) => theme.secondaryGrayLightSix};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryGray};
    text-decoration: none;
    background-color: transparent;
  }
  :hover {
    text-decoration: underline;
  }
`;

export const ContentDescriptLang = styled.div`
  font-size: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContentFlag = styled.p``;

export const useStyles = makeStyles(() => ({
  languages: (props) => ({
    boxShadow:
      (props.language.idLanguage || props.language.active) &&
      theme.button.buttonHoverShadow,
    transform:
      (props.language.idLanguage || props.language.active) &&
      "translateY(-1px)",
    "&:hover": {
      boxShadow: theme.button.buttonHoverShadow,
      transform: "translateY(-1px)",
    },
  }),
}));
